<template lang="pug">
  .main_search_field(v-click-outside="onClickOutside")
    .input_container_search_field(:class="[namespase]")
      input.store_search_field(v-model="showValue" readonly @click="touch")
      button.delete_search_field(:tabindex="-1" @click="clear") ✖
        //- i.fas.fa-times
    transition(name="fade")
      .search_container_search_field(v-if="dropdownOpen")
        .wrapper_search_field
          v-icon.i_serach_search_field(name="search" scale="0.9")
          input.input_search_field(:placeholder="placeholder" v-model="keywords" ref="input")
          div.count_search_field
            span Всего: {{fieldCount}}
        .select_search_field(v-if="dropdownOpen")
          div(@click.prevent v-if="results && results.length" v-for="result in results" @click="pickValue(result[search_by], result[show], result[additional_name])")
            v-icon(:name="icons" style="margin-right: 7px; margin-bottom: 3px; margin-left: 3px")
            span {{result[show]}}
            span(v-if="additional_name") {{', ' + result[additional_name]}}
          .list-overflow_search_field(v-if="fieldCount > 25")
            b Список не полный. Воспользуйтесь фильтром для уточнения запроса
          .not_found_search_field(v-if="!results.length")
            v-icon(name="times-circle" scale="1" style="margin-right: 5px; margin-bottom: 3px")
            span Совпадений не найдено

</template>

<script>
import axios from 'axios'
import Icon from 'vue-awesome/components/Icon'
import vClickOutside from 'v-click-outside'
import _ from 'lodash'

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    'v-icon': Icon
  },
  props: [
    'placeholder',
    'icons',
    'address',
    'api',
    'fieldAdd',
    'value',
    'search_by',
    'show',
    'additional_name',
    'defaultValue',
    'namespase'
  ],
  mounted () {
    setTimeout(() => {
      this.showValue = this.defaultValue || null
    }, 500)
  },
  data () {
    return {
      keywords: '',
      results: [],
      dropdownOpen: false,
      showValue: null,
      fieldCount: null
    }
  },
  created () {
    this.fetch()
  },
  watch: {
    keywords: _.debounce(function () {
      this.fetch()
    }, 1000),
    value (value) {
      if (!value) {
        this.showValue = value
      }
    }
  },
  methods: {
    touch () {
      this.dropdownOpen = !this.dropdownOpen
      if (this.dropdownOpen) {
        this.$nextTick(() => this.$refs.input.focus())
      }
    },
    pickValue (id, name, additionalName) {
      this.dropdownOpen = false
      this.keywords = null
      this.value = id
      !additionalName ? (additionalName = '') : (additionalName = ', ' + additionalName)
      this.showValue = name + additionalName
      this.keywords = ''
      this.$emit('input', this.value)
    },
    clear () {
      this.dropdownOpen = false
      this.keywords = null
      this.value = null
      this.showValue = null
      this.keywords = ''
      this.$emit('input', this.value)
    },
    fetch () {
      axios
        .get((this.api || 'dhra/api/v2/') + this.address + (this.keywords ? this.fieldAdd + this.keywords : this.keywords))
        .then(response => {
          this.results = response.data.results
          this.fieldCount = response.data.count
        })
        .catch(error => console.log(error))
    },
    onClickOutside () {
      if (this.dropdownOpen) {
        this.dropdownOpen = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>

.fade-enter-active, .fade-leave-active
  transition: opacity .35s
.fade-enter, .fade-leave-to
  opacity: 0

.main_search_field
  position: relative
.input_container_search_field
  max-height: 30px
  display: grid
  grid-template-columns:  auto 50px
  &:after
    content: ''
    position: absolute
    right: 75px
    top: 45%
    border: 5px solid transparent
    border-top: 6px  solid #555555
.store_search_field
  border: 1px solid #ccc
  border-radius: 4px 0 0 4px
  font-size: 15px
  color: #212121
  padding-left: 7px
  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s
  cursor: pointer
  border-radius: 4px 0 0 4px
.store_search_field:focus
  // border-color: rgba(26, 163, 255, 0.8)
  // box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(0, 153, 255, 0.6)
.search_container_search_field
  display: grid
  grid-template-colimns: 1fr
  width: 100%
  position: absolute
  z-index: 100
.i_serach_search_field
  position: absolute
  top: 8px
  left: 7px
  color: #8c8c8c
.input_search_field
  border: 1px solid rgba(26, 163, 255, 0.8)
  height: 30px
  padding-left: 27px
  background: #ebf7f9
  font-size: 13px
.wrapper_search_field
  background: #ebf7f9
  color: #8c8c8c
  height: 30px
  grid-row: 1
  display: grid
  grid-template-columns: minmax(min-content, 1fr) minmax(min-content, 100px)

.count_search_field
  text-align: right
  color: #999
  padding: 10px
  font-family: 'Roboto'
  font-size: small
button
  border-radius: 0 4px 4px 0
  border: 1px solid #ccc
  border-left: none
  background: white
  display: grid
  align-content: center
  justify-content: center
  cursor: pointer
  outline: none
.delete_search_field:hover
  transition: all, .3s
  color: #e2211d
  font-weight: bold
.select_search_field
  background: white
  border: 1px solid #ccc
  border-top: none
  border-radius: 0 0 4px 4px
  font-size: 15px
  max-height: 300px
  cursor: pointer
  overflow-y: auto
  overflow-x: hidden
  box-shadow: 0 3px 15px -10px black
.list-overflow_search_field
  background: #ebf7f9
  color: #999
  padding: 10px
  font-family: 'Roboto'
  font-size: small
  width: 100%
  // height: 30px
.select_search_field div
  display: flex
  align-items: center
  // height: 30px
  padding: 5px
  font-weight: 450
  // border-top: 1px dotted #ccc
.select_search_field div:first-child
    border-top: none
.select_search_field div:hover
  background: #1e90ff
  color: white
</style>
